import React, { createContext, useState, useContext, useEffect } from 'react';

const LocationContext = createContext();

export function LocationProvider({ children }) {
  const [currentLocation, setCurrentLocation] = useState({ 
    lat: 0, 
    lng: 0, 
    heading: 0, 
    speed: 0, 
    accuracy: 0,
    timestamp: Date.now()
  });
  const [watchId, setWatchId] = useState(null);
  const [locationError, setLocationError] = useState(null);
  const [isWatching, setIsWatching] = useState(false);

  const startWatchingLocation = () => {
    if (navigator.geolocation && !watchId) {
      const id = navigator.geolocation.watchPosition(
        ({ coords, timestamp }) => {
          const newLocation = {
            lat: coords.latitude,
            lng: coords.longitude,
            heading: coords.heading,
            speed: coords.speed,
            accuracy: coords.accuracy,
            timestamp: timestamp
          };
          setCurrentLocation(newLocation);
          setLocationError(null);
          setIsWatching(true);
        },
        (error) => {
          console.error("Geolocation error:", error);
          setLocationError(error);
        },
        { 
          enableHighAccuracy: true, 
          maximumAge: 0, 
          timeout: 5000 
        }
      );
      
      setWatchId(id);
    }
  };

  const stopWatchingLocation = () => {
    if (watchId) {
      navigator.geolocation.clearWatch(watchId);
      setWatchId(null);
      setIsWatching(false);
    }
  };

  const getGPSPosition = (position) => {
    if (position) {
      let LatLng = position.replace(/[()]/g, "").split(/\s*,\s*/);
      let Lat = parseFloat(LatLng[0]) ?? 0;
      let Lng = parseFloat(LatLng[1]) ?? 0;

      return {lat: Lat, lng: Lng}
    }
  }

  // Clean up on unmount
  useEffect(() => {
    return () => {
      if (watchId) {
        navigator.geolocation.clearWatch(watchId);
      }
    };
  }, [watchId]);

  const value = {
    currentLocation,
    setCurrentLocation, // For manual updates or testing
    locationError,
    isWatching,
    startWatchingLocation,
    stopWatchingLocation,
    getGPSPosition,
  };

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocation() {
  const context = useContext(LocationContext);
  if (context === undefined) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
} 